import { type PermissionOperation } from "../../shared/utils/BaseClient";

export const isWorkspaceOwnerOperationAllowed = (
  allowed: PermissionOperation[]
): boolean => {
  return (
    allowed.some(
      (op) =>
        op.resource.startsWith("crn:workspace:") &&
        !op.resource.includes("/org/") &&
        op.action === "protocol:read"
    ) &&
    allowed.some(
      (op) =>
        op.resource.startsWith("crn:workspace:") &&
        !op.resource.includes("/org/") &&
        op.action === "protocol:write"
    ) &&
    allowed.some(
      (op) =>
        op.resource.startsWith("crn:workspace:") &&
        !op.resource.includes("/org/") &&
        op.action === "protocol:delete"
    )
  );
};

export const isOrgAdminOperationAllowed = (
  allowed: PermissionOperation[]
): boolean => {
  return (
    allowed.some(
      (op) => op.resource.includes("/org/") && op.action === "protocol:read"
    ) &&
    allowed.some(
      (op) => op.resource.includes("/org/") && op.action === "protocol:write"
    ) &&
    allowed.some(
      (op) => op.resource.includes("/org/") && op.action === "protocol:delete"
    )
  );
};

export const isOrgCollaboratorOnlyOperationAllowed = (
  allowed: PermissionOperation[]
): boolean => {
  return (
    allowed.some(
      (op) => op.resource.includes("/org/") && op.action === "protocol:read"
    ) &&
    !allowed.some(
      (op) =>
        op.resource.includes("/org/") &&
        (op.action === "protocol:write" || op.action === "protocol:delete")
    ) &&
    !allowed.some((op) => !op.resource.includes("/org/"))
  );
};
